import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/frontend/node_modules/.pnpm/next@15.5.12_patch_hash=d565689395e00d268abee561b4a37e98174acd21796bca07cec95517e436fd0_8902ccab5f14b4211bb479f76898837b/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/frontend/src/components/public-site/PublicContent.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PublicContentFooter"] */ "/app/frontend/src/components/public-site/PublicContentFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoPublicHeader"] */ "/app/frontend/src/components/public-site/SeoPublicHeader.tsx");
